import { getVideoDurationAPI, getVideoThumbnailAPI, getVideoThumbnailsAPI } from '../util/api';

export const FETCH_VIDEO_DURATION_REQUEST = 'app/vimeo/FETCH_VIDEO_DURATION_REQUEST';
export const FETCH_VIDEO_DURATION_SUCCESS = 'app/vimeo/FETCH_VIDEO_DURATION_SUCCESS';
export const FETCH_VIDEO_DURATION_ERROR = 'app/vimeo/FETCH_VIDEO_DURATION_ERROR';

export const FETCH_VIDEO_THUMBNAIL_REQUEST = 'app/vimeo/FETCH_VIDEO_THUMBNAIL_REQUEST';
export const FETCH_VIDEO_THUMBNAIL_SUCCESS = 'app/vimeo/FETCH_VIDEO_THUMBNAIL_SUCCESS';
export const FETCH_VIDEO_THUMBNAIL_ERROR = 'app/vimeo/FETCH_VIDEO_THUMBNAIL_ERROR';

export const FETCH_VIDEO_THUMBNAILS_REQUEST = 'app/vimeo/FETCH_VIDEO_THUMBNAILS_REQUEST';
export const FETCH_VIDEO_THUMBNAILS_SUCCESS = 'app/vimeo/FETCH_VIDEO_THUMBNAILS_SUCCESS';
export const FETCH_VIDEO_THUMBNAILS_ERROR = 'app/vimeo/FETCH_VIDEO_THUMBNAILS_ERROR';

export const initialState = {
  isFetching: false,
  videoDuration: null,
  fetchError: null,
  isFetchingThumbnail: false,
  videoThumbnail: null,
  fetchThumbnailError: null,
  isFetchingThumbnails: false,
  videoThumbnails: [],
  fetchThumbnailsError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_VIDEO_DURATION_REQUEST:
      return { ...state, isFetching: true, fetchError: null };
    case FETCH_VIDEO_DURATION_SUCCESS:
      return { ...state, isFetching: false, videoDuration: payload, fetchError: null };
    case FETCH_VIDEO_DURATION_ERROR:
      return { ...state, isFetching: false, fetchError: payload };
    case FETCH_VIDEO_THUMBNAIL_REQUEST:
      return { ...state, isFetchingThumbnail: true, fetchThumbnailError: null };
    case FETCH_VIDEO_THUMBNAIL_SUCCESS:
      return {
        ...state,
        isFetchingThumbnail: false,
        videoThumbnail: payload,
        fetchThumbnailError: null,
      };
    case FETCH_VIDEO_THUMBNAIL_ERROR:
      return { ...state, isFetchingThumbnail: false, fetchThumbnailError: payload };
    case FETCH_VIDEO_THUMBNAILS_REQUEST:
      return { ...state, isFetchingThumbnails: true, fetchThumbnailsError: null };
    case FETCH_VIDEO_THUMBNAILS_SUCCESS:
      return {
        ...state,
        isFetchingThumbnails: false,
        videoThumbnails: payload,
        fetchThumbnailsError: null,
      };
    case FETCH_VIDEO_THUMBNAILS_ERROR:
      return { ...state, isFetchingThumbnails: false, fetchThumbnailsError: payload };
    default:
      return state;
  }
}

// ================ Action creators ================ //

export const fetchVideoDurationRequest = () => ({ type: FETCH_VIDEO_DURATION_REQUEST });
export const fetchVideoDurationSuccess = duration => ({
  type: FETCH_VIDEO_DURATION_SUCCESS,
  payload: duration,
});
export const fetchVideoDurationError = error => ({
  type: FETCH_VIDEO_DURATION_ERROR,
  payload: error,
});

export const fetchVideoThumbnailRequest = () => ({ type: FETCH_VIDEO_THUMBNAIL_REQUEST });
export const fetchVideoThumbnailSuccess = thumbnail => ({
  type: FETCH_VIDEO_THUMBNAIL_SUCCESS,
  payload: thumbnail,
});
export const fetchVideoThumbnailError = error => ({
  type: FETCH_VIDEO_THUMBNAIL_ERROR,
  payload: error,
});

export const fetchVideoThumbnailsRequest = () => ({ type: FETCH_VIDEO_THUMBNAILS_REQUEST });
export const fetchVideoThumbnailsSuccess = thumbnails => ({
  type: FETCH_VIDEO_THUMBNAILS_SUCCESS,
  payload: thumbnails,
});
export const fetchVideoThumbnailsError = error => ({
  type: FETCH_VIDEO_THUMBNAILS_ERROR,
  payload: error,
});

// ================ Selectors ================ //

export const fetchVideoDurationData = state => {
  return {
    videoDuration: state.vimeo.videoDuration,
    isFetching: state.vimeo.isFetching,
    fetchError: state.vimeo.fetchError,
  };
};

export const fetchVideoThumbnailData = state => {
  return {
    videoThumbnail: state.vimeo.videoThumbnail,
    isFetchingThumbnail: state.vimeo.isFetchingThumbnail,
    fetchThumbnailError: state.vimeo.fetchThumbnailError,
  };
};

export const fetchVideoThumbnailsData = state => {
  return {
    videoThumbnails: state.vimeo.videoThumbnails,
    isFetchingThumbnails: state.vimeo.isFetchingThumbnails,
    fetchThumbnailsError: state.vimeo.fetchThumbnailsError,
  };
};

// ================ Thunks ================ //

export const fetchVideoDuration = (params = {}) => async (dispatch, getState, sdk) => {
  dispatch(fetchVideoDurationRequest());
  try {
    const result = await getVideoDurationAPI(params);
    dispatch(fetchVideoDurationSuccess(result.duration));
    return result;
  } catch (error) {
    console.error('Error fetching video duration:', error);
    dispatch(fetchVideoDurationError(error.message || 'Failed to fetch video duration'));
    throw error;
  }
};

export const fetchVideoThumbnail = (params = {}) => async (dispatch, getState, sdk) => {
  dispatch(fetchVideoThumbnailRequest());
  try {
    const result = await getVideoThumbnailAPI(params);
    dispatch(fetchVideoThumbnailSuccess(result.thumbnail));
    return result;
  } catch (error) {
    console.error('Error fetching video thumbnail:', error);
    dispatch(fetchVideoThumbnailError(error.message || 'Failed to fetch video thumbnail'));
    throw error;
  }
};

export const fetchVideoThumbnails = (params = {}) => async (dispatch, getState, sdk) => {
  dispatch(fetchVideoThumbnailsRequest());
  try {
    const result = await getVideoThumbnailsAPI(params);
    dispatch(fetchVideoThumbnailsSuccess(result.thumbnails));
    return result;
  } catch (error) {
    console.error('Error fetching video thumbnails:', error);
    dispatch(fetchVideoThumbnailsError(error.message || 'Failed to fetch video thumbnails'));
    throw error;
  }
};
